(function (factory) {
	typeof define === 'function' && define.amd ? define('@shraddhar/mdc-test-web', factory) :
	factory();
}((function () { 'use strict';

	// All components should be imported through their individual entry-points. This file
	// is needed to satisfy the "ng_package" bazel rule which also requires a primary entry-point.

})));
//# sourceMappingURL=web.umd.js.map
